export default __webpack_public_path__ + "static/media/newArrest.d7757575.png";